import axios from "axios";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import ErrorMessage from "components/common/ErrorMessage";
import PhoneInput from "components/common/PhoneInput";
import { selectCustomStyles } from "components/common/Select";
import { Trash2Icon } from "lucide-react";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AsyncPaginate } from "react-select-async-paginate";
import Api from "services/api";
import { fetchLanguages } from "slices/languageSlice";
import { fetchTypes } from "slices/typeSlice";
import Swal from "sweetalert2";

const AddTranslatoinForm = ({ item }) => {
  console.log("itemlan", item);
  const [isloading, setIsloading] = useState(false);
  const navigate = useNavigate();
  const onSubmit = async (data) => {
    setIsloading(true);
    const formData = new FormData();
    formData.append("account_id", data.account_id ?? null);
    formData.append("requester_email", data.requester_email ?? "");
    formData.append("requester_name", data.requester_name ?? "");
    formData.append("requester_phone", data.requester_phone ?? "");
    formData.append("due_date", data.due_date ?? "");
    formData.append("comment", data.comment ?? "");
    formData.append("formatting", data.formatting ? 1 : 0);
    formData.append("rush", data.rush ? 1 : 0);

    // Append target_languages as target_languages[0], target_languages[1], ...
    if (Array.isArray(data.target_languages)) {
      data.target_languages.forEach((id, idx) => {
        formData.append(`target_languages[${idx}]`, id ?? null);
      });
    } else if (data.target_languages) {
      formData.append("target_languages[0]", data.target_languages ?? null);
    }

    // Append source_language_id as a single value (not array)
    if (
      Array.isArray(data.source_language_id) &&
      data.source_language_id.length > 0
    ) {
      formData.append("source_language_id", data.source_language_id[0] ?? null);
    } else if (data.source_language_id) {
      formData.append("source_language_id", data.source_language_id ?? null);
    }

    // Append files as files[0][file] and files[0][password]
    if (Array.isArray(data.files)) {
      data.files.forEach((file, idx) => {
        formData.append(`files[${idx}][file]`, file);
        if (filePasswords && filePasswords[idx]) {
          formData.append(`files[${idx}][password]`, filePasswords[idx]);
        } else {
          formData.append(`files[${idx}][password]`, "");
        }
      });
    }

    // console.log("data", data);
    try {
      const response = await Api?.submitTranslation(formData);
      if (response.status === 200) {
        // console.log("Submission successful!", response);
        // toast.success(response?.data?.message);
        toast.success(response?.data?.message, {
          className: "successToast",
        });
        Swal.fire({
          title: "Success!",
          text: response?.data?.message,
          icon: "success",
        }).then(() => {
          navigate(`/translation/view/${response?.data?.data?.id}`);
        });
      }
    } catch (error) {
      console.error("Submission failed:", error);
      toast.error(error?.data?.message || String(error), {
        className: "errorToast",
      });
    } finally {
      setIsloading(false);
    }
  };

  // Drag and drop state
  const {
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm();
  const dispatch = useDispatch();
  const [dragActive, setDragActive] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [filePasswords, setFilePasswords] = useState({});
  const inputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleBrowseClick = () => {
    inputRef.current.click();
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      console.log("updated", updated);
      setValue("files", updated);
      return updated;
    });
    setFilePasswords((prev) => {
      const newPwds = { ...prev };
      delete newPwds[index];
      return newPwds;
    });
  };

  const handlePasswordChange = (index, value) => {
    setFilePasswords((prev) => ({ ...prev, [index]: value }));
  };

  // #region Language dropdown
  const [languageState, setLanguageState] = useState([]);

  useEffect(() => {
    setLanguageState(
      item?.languages?.map((val) => ({
        label: val?.language?.name || "",
        value: val?.language?.id || "",
      }))
    );
    console.log("lan", item?.language);
  }, [item?.languages]);

  const [sourcelanguageState, setSourceLanguageState] = useState([]);

  useEffect(() => {
    setSourceLanguageState(
      item?.languages?.map((val) => ({
        label: val?.language?.name || "",
        value: val?.language?.id || "",
      }))
    );
  }, [item?.languages]);

  const filteredLanguagesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchLanguages(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((language) => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  //#region Client dropdown
  const [filterClients, setfilterClients] = useState({
    label: "",
    value: "",
  });

  useEffect(() => {
    if (item?.accounts?.user?.name && item?.accounts?.user?.id) {
      setfilterClients({
        label: item?.accounts?.user?.name || "",
        value: item?.accounts?.user?.id || "",
      });
    } else {
      setfilterClients(null);
    }
  }, [item?.accounts?.user]);

  const filteredClientsLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchTypes(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  return (
    <div
      className="content"
      style={{
        maxWidth: 900,
        minWidth: 700,
        background: "#fff",
        marginBottom: 40,
        marginTop: 110,
        borderRadius: 24,
        boxShadow: "0 4px 24px #e0e7ef",
        padding: 36,
      }}
    >
      <h1
        className="modal-title_u"
        style={{
          textAlign: "center",
          marginBottom: 38,
          color: "#6c889c",
        }}
      >
        Translation Form
      </h1>

      <form
        style={{ display: "flex", flexDirection: "column", gap: 24 }}
        onSubmit={handleSubmit(onSubmit)}
      >
        {/* Client SELECT */}
        <div className="row-primary">
          <h2>Client*</h2>
          <div className="w-100">
            <Controller
              name="account_id"
              control={control}
              rules={{
                required: "Please select a client",
                validate: (value) =>
                  value !== null && value !== ""
                    ? true
                    : "Please select a client",
              }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement="auto"
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={filterClients}
                    loadOptions={filteredClientsLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(obj) => {
                      if (obj?.value) {
                        setfilterClients(obj);
                        field.onChange(obj.value);
                      } else {
                        setfilterClients({
                          label: "",
                          value: "",
                        });
                        field.onChange(null);
                      }
                    }}
                    additional={{
                      page: item?.state?.id ? 2 : 1,
                    }}
                  />
                  {errors?.account_id?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.account_id?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>
        </div>

        {/* Source Language  */}
        <div className="row-primary">
          <h2>Source Language</h2>
          <Controller
            name="source_language_id"
            required
            rules={{
              required: "Source language is required",
            }}
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement="auto"
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={sourcelanguageState}
                    loadOptions={filteredLanguagesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setSourceLanguageState(selected);
                      field.onChange(selected ? selected.value : null);
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.source_language_id?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.source_language_id?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>

        {/* Target Language  */}
        <div className="row-primary">
          <h2>Target Language*</h2>
          <Controller
            name="target_languages"
            required
            rules={{
              required: "Target language is required",
            }}
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement="auto"
                    isMulti
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={languageState}
                    loadOptions={filteredLanguagesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setLanguageState(selected);
                      field.onChange(selected.map((opt) => opt.value));
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.target_languages?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.target_languages?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>

        {/* REQUESTER */}
        <div className="row-primary">
          <h2>Requestor*</h2>
          <div className="w-100">
            <Controller
              name="requester_name"
              rules={{
                required: "Requestor name is required",
              }}
              control={control}
              render={({ field }) => (
                <input
                  className="input-in type_inp"
                  placeholder="requester name"
                  type="text"
                  {...field}
                />
              )}
            />
            {errors?.requester_name?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.requester_name?.message} />
              </div>
            )}
          </div>
        </div>

        {/* REQUESTOR EMAIL */}
        <div className="row-primary">
          <h2>Requestor Email</h2>
          <div className="w-100">
            <Controller
              // rules={{
              //   required: "Requestor Email is required",
              //   pattern: {
              //     value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              //     message: "Invalid email format",
              //   },
              // }}
              name="requester_email"
              control={control}
              render={({ field }) => (
                <input
                  required={true}
                  placeholder="requester email"
                  className="input-in type_inp"
                  type="email"
                  pattern={/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/}
                  {...field}
                />
              )}
            />
            {Array.isArray(errors?.requester_email)
              ? errors.requester_email.map((error, idx) => (
                  <div style={{ marginBottom: 10 }} key={idx}>
                    <ErrorMessage text={error} />
                  </div>
                ))
              : errors?.requester_email?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.requester_email?.message} />
                  </div>
                )}
          </div>
        </div>

        {/* Phone Field   */}
        <div className="row-primary">
          <h2>Phone Number</h2>
          <div className="w-100">
            <Controller
              name="requester_phone"
              control={control}
              render={({ field }) => (
                <PhoneInput
                  className="input-in type_inp"
                  type="tel"
                  name="phone"
                  placeholder="Phone number"
                  required
                  {...field}
                />
              )}
            />
            {Array.isArray(errors?.requester_phone)
              ? errors.requester_phone.map((error, idx) => (
                  <div style={{ marginBottom: 10 }} key={idx}>
                    <ErrorMessage text={error} />
                  </div>
                ))
              : errors?.requester_phone?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.requester_phone?.message} />
                  </div>
                )}
          </div>
        </div>

        {/* Due Date  */}
        <div className="row-primary">
          <h2>Due Date</h2>
          <Controller
            name="due_date"
            control={control}
            // rules={{
            //   required: "duee date is required",
            // }}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div className="input-image">
                  <input
                    id="due_date"
                    type="date"
                    name="due_date"
                    placeholder="YYYY-MM-DD"
                    {...field}
                    value={field.value ? field?.value : ""}
                    onPaste={(e) => {
                      e.preventDefault(); // Prevent default paste behavior
                      const pastedData = e.clipboardData.getData("text"); // Get pasted text
                      const dateString = moment
                        .utc(pastedData)
                        .format("YYYY-MM-DD");

                      if (moment(dateString, "YYYY-MM-DD", true).isValid()) {
                        field.onChange(dateString);
                      } else {
                        console.warn("Invalid date format");
                      }
                    }}
                    onChange={(e) => {
                      const dateString = moment
                        .utc(e.target.value)
                        .format("YYYY-MM-DD");
                      field.onChange(dateString);
                    }}
                  />
                  <img
                    src="/images/celender.png"
                    alt="celender Icon"
                    className="custom-icon"
                  />
                </div>
                {errors?.due_date?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.due_date?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>

        {/* Comment */}
        <div className="row-primary">
          <h2>Comment</h2>
          <div className="w-100">
            <Controller
              name="comment"
              // rules={{
              //   required: "Requestor name is required",
              // }}
              control={control}
              render={({ field }) => (
                <textarea
                  className="input-in type_inp"
                  placeholder="Comment"
                  type="text"
                  {...field}
                />
              )}
            />
            {errors?.comment?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.comment?.message} />
              </div>
            )}
          </div>
        </div>

        {/* Formatting Check box */}
        <div className="row-primary" style={{ marginBottom: 0 }}>
          <div
            className="w-100"
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            <Controller
              name="formatting"
              control={control}
              defaultValue={false}
              // rules={{
              //   validate: (value) => value === true || "Formatting is required",
              // }}
              render={({ field }) => (
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    marginBottom: 0,
                  }}
                >
                  <input
                    id="formatting"
                    type="checkbox"
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                    style={{ display: "none" }}
                  />
                  <span
                    style={{
                      width: 44,
                      height: 24,
                      background: !!field.value ? "#1AD598" : "#e0e7ef",
                      borderRadius: 24,
                      position: "relative",
                      transition: "background 0.2s",
                      display: "inline-block",
                      marginRight: 12,
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: !!field.value ? 22 : 2,
                        top: 2,
                        width: 20,
                        height: 20,
                        background: "#fff",
                        borderRadius: "50%",
                        boxShadow: "0 1px 4px #b0b8c9",
                        transition: "left 0.2s",
                      }}
                    />
                  </span>
                  <span style={{ fontWeight: 500, color: "#6c889c" }}>
                    Formatting/desktop publishing (DTP)?
                  </span>
                </label>
              )}
            />
            {errors?.formatting?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.formatting?.message} />
              </div>
            )}
          </div>
        </div>

        {/* rush Check box */}
        <div className="row-primary" style={{ marginTop: 0 }}>
          <div
            className="w-100"
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            <Controller
              name="rush"
              control={control}
              defaultValue={false}
              // rules={{
              //   validate: (value) => value === true || "Rush is required",
              // }}
              render={({ field }) => (
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    marginBottom: 0,
                  }}
                >
                  <input
                    id="rush"
                    type="checkbox"
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                    style={{ display: "none" }}
                  />
                  <span
                    style={{
                      width: 44,
                      height: 24,
                      background: !!field.value ? "#1AD598" : "#e0e7ef",
                      borderRadius: 24,
                      position: "relative",
                      transition: "background 0.2s",
                      display: "inline-block",
                      marginRight: 12,
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: !!field.value ? 22 : 2,
                        top: 2,
                        width: 20,
                        height: 20,
                        background: "#fff",
                        borderRadius: "50%",
                        boxShadow: "0 1px 4px #b0b8c9",
                        transition: "left 0.2s",
                      }}
                    />
                  </span>
                  <span style={{ fontWeight: 500, color: "#6c889c" }}>
                    Rush/Expedited
                  </span>
                </label>
              )}
            />
            {errors?.rush?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.rush?.message} />
              </div>
            )}
          </div>
        </div>

        {/* File upload box at the bottom with drag and drop */}
        <div>
          <Controller
            name="files"
            control={control}
            defaultValue={[]}
            rules={{
              required: "Please upload at least one file",
              validate: (value) =>
                value.length > 0 || "Please upload at least one file",
            }}
            render={({ field }) => (
              <div
                onDragEnter={(e) => {
                  handleDrag(e);
                }}
                onDragOver={(e) => {
                  handleDrag(e);
                }}
                onDragLeave={(e) => {
                  handleDrag(e);
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setDragActive(false);
                  if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                    // const filesArr = Array.from(e.dataTransfer.files).filter(
                    //   (file) => file.type.startsWith("image/")
                    // );
                    setSelectedFiles((prev) => {
                      const newFiles = [...prev, ...e.dataTransfer.files];
                      field.onChange(newFiles);
                      return newFiles;
                    });
                  }
                }}
                style={{
                  height: 240,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  border: dragActive ? "2px solid #1976d2" : "2px dashed #ccc",
                  borderRadius: 8,
                  padding: 32,
                  textAlign: "center",
                  marginTop: 16,
                  marginBottom: 10,
                  background: dragActive ? "#e3f2fd" : "#fafbff",
                  transition: "all 0.2s",
                  position: "relative",
                  outline: dragActive ? "2px solid #1976d2" : "none",
                }}
              >
                <input
                  type="file"
                  ref={inputRef}
                  style={{ display: "none" }}
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  multiple
                  onChange={(e) => {
                    if (e.target.files && e.target.files.length > 0) {
                      // const filesArr = Array.from(e.target.files).filter((file) =>
                      //   file.type.startsWith("image/")
                      // );
                      setSelectedFiles((prev) => {
                        const newFiles = [...prev, ...e.target.files];
                        field.onChange(newFiles);
                        return newFiles;
                      });
                      setValue("");
                    }
                  }}
                />
                <div
                  style={{
                    color: "#6F8DFF",
                    fontWeight: 600,
                    fontSize: 22,
                    marginBottom: 16,
                  }}
                >
                  Browse or Drag and Drop{" "}
                  <span
                    style={{
                      color: "#6c889c",
                      fontWeight: 400,
                      fontSize: 18,
                      marginLeft: 12,
                    }}
                  >
                    (.doc, .docx, .pdf, .jpg, .jpeg, .png)
                  </span>
                </div>
                <SubmitButton
                  btnText="Browse Files"
                  buttonType="button"
                  handleSubmit={handleBrowseClick}
                />
              </div>
            )}
          />
          {errors?.files?.message && (
            <div style={{ color: "red", marginTop: 8 }}>
              {errors.files.message}
            </div>
          )}
        </div>

        {/* Table for selected images */}
        {selectedFiles.length > 0 && (
          <div
            style={{
              marginTop: 4,
              marginBottom: 14,
              borderRadius: 14,
              overflow: "hidden",
              boxShadow: "0 2px 12px #e0e7ef",
              background: "#f8fafc",
              border: "1.5px solid #e0e7ef",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "separate",
                borderSpacing: 0,
                background: "#f8fafc",
                fontSize: 15,
                color: "#6c889c",
              }}
            >
              <thead>
                <tr style={{ background: "#f4f7fb" }}>
                  <th
                    style={{
                      padding: "16px 10px",
                      fontWeight: 700,
                      textAlign: "left",
                      color: "#6c889c",
                      borderBottom: "1.5px solid #e0e7ef",
                    }}
                  >
                    #
                  </th>
                  <th
                    style={{
                      padding: "16px 8px",
                      fontWeight: 700,
                      textAlign: "left",
                      color: "#6c889c",
                      borderBottom: "1.5px solid #e0e7ef",
                      borderLeft: "1.5px solid #e0e7ef",
                    }}
                  >
                    File
                  </th>
                  <th
                    style={{
                      padding: "16px 8px",
                      fontWeight: 700,
                      textAlign: "left",
                      color: "#6c889c",
                      borderBottom: "1.5px solid #e0e7ef",
                      borderLeft: "1.5px solid #e0e7ef",
                      borderRight: "1.5px solid #e0e7ef",
                    }}
                  >
                    Password (if any)
                  </th>
                  <th
                    style={{
                      padding: "16px 8px",
                      fontWeight: 700,
                      textAlign: "left",
                      color: "#6c889c",
                      borderBottom: "1.5px solid #e0e7ef",
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {selectedFiles.map((file, idx) => (
                  <tr
                    key={idx}
                    style={{ background: idx % 2 === 0 ? "#fff" : "#f8fafc" }}
                  >
                    <td
                      style={{
                        padding: "14px 8px",
                        textAlign: "center",
                        borderBottom: "1px solid #e0e7ef",
                        borderRight: "1.5px solid #e0e7ef",
                      }}
                    >
                      {idx + 1}
                    </td>
                    <td
                      style={{
                        padding: "14px 8px",
                        borderBottom: "1px solid #e0e7ef",
                        borderRight: "1.5px solid #e0e7ef",
                      }}
                    >
                      {file.name}
                    </td>
                    <td
                      style={{
                        padding: "14px 8px",
                        borderBottom: "1px solid #e0e7ef",
                        borderRight: "1.5px solid #e0e7ef",
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Password"
                        value={filePasswords[idx] || ""}
                        onChange={(e) =>
                          handlePasswordChange(idx, e.target.value)
                        }
                        style={{
                          width: "90%",
                          padding: "10px 14px",
                          border: "1.5px solid #e0e7ef",
                          borderRadius: 8,
                          fontSize: 15,
                          outline: "none",
                          background: "#f8fafc",
                          color: "#6c889c",
                          transition: "border 0.2s, box-shadow 0.2s",
                        }}
                        onFocus={(e) =>
                          (e.target.style.border = "1.5px solid #1976d2")
                        }
                        onBlur={(e) =>
                          (e.target.style.border = "1.5px solid #e0e7ef")
                        }
                      />
                    </td>
                    <td
                      style={{
                        padding: "14px 8px",
                        textAlign: "center",
                        borderBottom: "1px solid #e0e7ef",
                      }}
                    >
                      <span
                        onClick={() => handleRemoveFile(idx)}
                        style={{
                          color: "#d32f2f",
                          cursor: "pointer",
                          fontWeight: 600,
                          textDecoration: "underline",
                          padding: "8px 10px",
                          borderRadius: 6,
                          transition: "background 0.15s",
                          userSelect: "none",
                          display: "inline-block",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.background = "#ffeaea")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                        role="button"
                        tabIndex={0}
                      >
                        <Trash2Icon size={18} />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <SubmitButton
          btnText={isloading ? "loading..." : "Submit »"}
          buttonType="button"
          handleSubmit={handleSubmit(onSubmit)}
          loader={isloading}
        />
      </form>
    </div>
  );
};

export default AddTranslatoinForm;
